import { formatTimeAgo } from "../formatTimeAgo";
import { LolBinActivityData, LolBinTimelineData, TopLolBinComputerData, TopLolBinData, TopLolBinUserData } from "../interfaces/CommonInterfaces";

export const mapLolbinTimeline = (response: any): LolBinTimelineData[] => {
  return (response.eventTimeLine || []).map((item: any) => ({
    date: item.date,
    activity: item.count,
  }));
};


export const mapLolbinActivity = (response: any): LolBinActivityData[] => {
  return (response.lastest1000Result || []).map((item: any, idx: number) => {
    const message = item.message || "";

    // Regex parse
    const pidMatch = message.match(/pid:\s+(\d+)/);
    const launchedAppMatch = message.match(/launched application:\s+(\S+)/);
    const launchedPidMatch = message.match(/with pid:\s+(\d+)/);
    const userMatch = message.match(/for user:\s+(\S+)/);

    return {
      id: `${idx}`,
      timeAgo: item.timestamp ? formatTimeAgo(item.timestamp) : item._time ? formatTimeAgo(item._time) : "",
      processPath: message,
      pid: pidMatch ? pidMatch[1] : "",
      launchedApp: launchedAppMatch ? launchedAppMatch[1] : "",
      launchedPid: launchedPidMatch ? launchedPidMatch[1] : "",
      user: userMatch ? userMatch[1] : item.computerUserEmail || "",
      computerName: item.computerName || "",
    };
  });
};

export const mapTopLolbin = (response: any): TopLolBinData[] => {
  const data = response.resourceName || [];
  const total = data.reduce((sum: number, item: any) => sum + item.count, 0);

  return data.map((item: any, idx: number) => ({
    id: `lolbin-${idx}`,
    executable: item.name,
    percentage: total > 0 ? (item.count / total) * 100 : 0,
  }));
};


export const mapTopLolbinUsers = (response: any): TopLolBinUserData[] => {
  const data = response.computerUserEmail || [];
  const total = data.reduce((sum: number, item: any) => sum + item.count, 0);

  return data.map((item: any, idx: number) => ({
    id: `user-${idx}`,
    username: item.name,
    percentage: total > 0 ? (item.count / total) * 100 : 0,
  }));
};

export const mapTopLolbinComputers = (response: any): TopLolBinComputerData[] => {
  const data = response.computerName || [];
  const total = data.reduce((sum: number, item: any) => sum + item.count, 0);

  return data.map((item: any, idx: number) => ({
    id: `computer-${idx}`,
    computerName: item.name,
    percentage: total > 0 ? (item.count / total) * 100 : 0,
  }));
};
